/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { domainNameToFileName, environment, environmentAsync } from './environments/environment.prod';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
/*import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './_lib/service/auth.interceptor';*/

(async () => {
  await environmentAsync;

  if (environment.production) {
    enableProdMode();
  }

 /* const providers = [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ];*/

  // Only run browser-specific code safely
  if (typeof window !== 'undefined') {
    loadDynamicTheme();
  }

  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error('Bootstrap error:', err));
})();

function loadDynamicTheme(): void {
  const domain = window.location.hostname.toLowerCase();
  const themeFile = `${domainNameToFileName(domain)}.css`;
  const linkEl = document.createElement('link');
  linkEl.rel = 'stylesheet';
  linkEl.type = 'text/css';
  linkEl.href = `assets/themes/${themeFile}`;
  linkEl.onerror = () => {
    linkEl.href = 'assets/themes/karlkustoms.css';
  };
  // Once the browser's theme <link> has loaded, remove the SSR-injected
  // <style id="ssr-theme-css"> so there are no duplicate style rules.
  const removeSsrStyle = () => {
    document.getElementById('ssr-theme-css')?.remove();
  };
  linkEl.addEventListener('load', removeSsrStyle, { once: true });
  linkEl.addEventListener('error', removeSsrStyle, { once: true });
  document.head.appendChild(linkEl);
}